/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskEvaluationConfigOutputCompletionMinLevelsOverrideAnyOf } from './taskEvaluationConfigOutputCompletionMinLevelsOverrideAnyOf';

export type TaskEvaluationConfigOutputCompletionMinLevelsOverride =
  TaskEvaluationConfigOutputCompletionMinLevelsOverrideAnyOf | null;
